import "@/App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Landing from "@/pages/Landing";
import About from "@/pages/About";
import Founder from "@/pages/Founder";
import Process from "@/pages/Process";
import Contact from "@/pages/Contact";
import Policies from "@/pages/Policies";
import Login from "@/pages/Login";
import SignIn from "@/pages/SignIn";
import ResetPassword from "@/pages/ResetPassword";
import MyFavourites from "@/pages/MyFavourites";
import MyHome from "@/pages/MyHome";
import VendorApply from "@/pages/VendorApply";
import CoupleSignup from "@/pages/CoupleSignup";
import VendorListing from "@/pages/VendorListing";
import Admin from "@/pages/Admin";
import ChooseRole from "@/pages/ChooseRole";
import Category from "@/pages/Category";
import VendorProfile from "@/pages/VendorProfile";
import AuthCallback from "@/pages/AuthCallback";
import { Toaster } from "@/components/ui/sonner";

function AppRouter() {
  const location = useLocation();
  // Detect Emergent OAuth callback synchronously during render.
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/about" element={<About />} />
      <Route path="/founder" element={<Founder />} />
      <Route path="/process" element={<Process />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/policies" element={<Policies />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signin" element={<SignIn />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/my-favourites" element={<MyFavourites />} />
      <Route path="/my-home" element={<MyHome />} />
      <Route path="/vendor/apply" element={<VendorApply />} />
      <Route path="/couple/signup" element={<CoupleSignup />} />
      <Route path="/vendor-listing" element={<VendorListing />} />
      <Route path="/category/:slug" element={<Category />} />
      <Route path="/vendors/:slug" element={<VendorProfile />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/choose-role" element={<ChooseRole />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
